import { CoreCsvUploadType } from '@repo/csv'

export const ON_HAND_INVENTORY_UPLOAD_TYPES: CoreCsvUploadType[] = [
  'on-hand-inventory-partial',
  'on-hand-inventory-uom',
  'on-hand-inventory-duns',
] as const
